import React from "react"
import styled from "styled-components"
import posed, { PoseGroup } from "react-pose"
import { findColor, Flex, Text } from "@jjordy/layout"
import { FaTimes } from "react-icons/fa"

const AnimatedMessage = posed.div({
  enter: { opacity: 1 },
  exit: { opacity: 0 }
})

const MyMessage = styled(AnimatedMessage)`
  position: fixed;
  top: 0;
  border-radius: 0;
  margin-top: 64px;
  background-color: ${(props) => findColor(props, "success").hex()};
  z-index: 2;
  left: 0;
  width: 100%;

  & .close-button {
    border: 0;
    background-color: transparent;

    & svg {
      fill: white;
    }
  }
`

export interface MessageProps {
  visible?: boolean
  onClose?: () => void
  text?: React.ReactNode | string
  bg?: string
}
const FinalMessage = ({ visible, onClose, text, bg }: MessageProps) => (
  <PoseGroup flipMove={false}>
    {visible && (
      <MyMessage bg={bg || "success"} key="message">
        <Flex py={1} px={2} justify="space-between">
          <Text fg="white" strong m={0}>
            {text}
          </Text>
          <button className="close-button" onClick={onClose} aria-label="Close Message">
            <FaTimes />
          </button>
        </Flex>
      </MyMessage>
    )}
  </PoseGroup>
)

export default FinalMessage
